module.exports = __webpack_public_path__ + "img/empty-product.25b78e7b.png";